const EMBLA_DEFAULT_OPTIONS = {
  slidesPerView: 3,
  slideSpacing: "12px",
  offset: "0px",
  fade: false,
  autoplay: false,
  playOnInit: false,
  dragFree: true
};
const EMBLA_NAVIGATION_DEFAULT_OPTIONS = {
  navigation_width: "100%",
  margin: "0",
  position: "right" /* RIGHT */
};

export { EMBLA_DEFAULT_OPTIONS, EMBLA_NAVIGATION_DEFAULT_OPTIONS };
//# sourceMappingURL=types.js.map
